export const verdantIdAttribute = 'data-verdant-oid';
export const fileKeyAttribute = 'data-verdant-file-key';
export const fileTypeAttribute = 'data-verdant-file-type';
export const fileNameAttribute = 'data-verdant-file-name';
export const fileIdAttribute = 'data-verdant-file-id';
//# sourceMappingURL=attributes.js.map